import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["border-collapse:collapse;text-align:left;width:100%;"]);
/**
 * Renders a `table` element with some default styles.
 *
 * @public
 * @author Connor Taylor
 */

var Table = makeThemedComponent({
  themeKey: "Table",
  component: "table",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default Table;